import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { getAppropriateCanonicalUrl } from '../utils/canonical';

/**
 * Custom hook to set canonical URL for a page
 * @param {string} customPath - Optional custom path (defaults to current path)
 * @param {boolean} forceWww - Force www version (defaults to current domain preference)
 */
const useCanonical = (customPath = null, forceWww = null) => {
    const canonicalUrl = getAppropriateCanonicalUrl(customPath);
    
    return (
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
        </Helmet>
    );
};

export default useCanonical;
